import React from "react";

import useStepDeliveryAddress from "../store";
import AdditionalAddress from "./AdditionalAddress";

const MultipleUnloadingPoints = ({ showDelete = true }) => {
    const [additionalAddresses] = useStepDeliveryAddress((state) => [
        state.additionalAddresses,
    ]);

    return (
        <div>
            {additionalAddresses.map((address, index) => (
                <AdditionalAddress
                    key={`aa${index}`}
                    index={index}
                    showDelete={showDelete}
                />
            ))}
        </div>
    );
};

export default MultipleUnloadingPoints;
